import React, { useState, useMemo } from 'react';
import { Pressable, StyleSheet, Platform, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';

const createStyles = (colors) => StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: 'transparent',
    borderRadius: 17,
    height: 34,
    minWidth: 34,
    paddingHorizontal: 8,
    ...Platform.select({
      web: {
        transition: 'all 0.2s ease',
        cursor: 'pointer',
      }
    })
  },
  buttonHovered: {
    backgroundColor: colors.solid_color_tertiary,
  },
  inner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  buttonDot: {
    position: 'absolute',
    top: 3,
    right: 3,
    width: 10,
    height: 10,
    borderRadius: 10,
    backgroundColor: 'rgb(255, 40, 40)',
    borderWidth: 2,
    borderColor: colors.solid_color_primary,
  },
});

export default function ChatInputMobileMenuButton({ onPress, isMissingRequiredParameters }) {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable
      hitSlop={{ top: 5, bottom: 5, left: 5, right: 5 }}
      style={[styles.button, isHovered && styles.buttonHovered]}
      onPress={onPress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <View style={styles.inner}>
        <Icon name="sliders-simple" size={14} color={colors.text_color_primary} />
      </View>
      {isMissingRequiredParameters ? <View style={styles.buttonDot} /> : null}
    </Pressable>
  );
}


